import React, { useState, useEffect } from 'react';
import './rpt_ejecucion_tabla.css'

const TablaEjecucionSemana = (p) => {
    const [seleccionesLocal, setseleccionesLocal] = useState({ index: -1, verDias: -1 });
    const [reporteFormato, setreporteFormato] = useState([]);

    useEffect(() => {
        setseleccionesLocal({ index: -1, verDias: -1 });
        formatearReporte();
    }, [p.datos]);

    const formatearReporte = () => {
        const datos = p.datos ?? [];
        const formato = {};
        for (const item of datos) {
            const bloque = item.bloque;
            const semana = item.semana_trasplante;
            if (!formato[semana]) {
                formato[semana] = {
                    semana: semana,
                    bloques: {},
                    total_plan: 0,
                    total_ejecutado: 0,
                    bloques_array: [],
                };
            }
            formato[semana].total_plan += (item.plan_plantas ?? 0);
            formato[semana].total_ejecutado += (item.total_plantas ?? 0);


            if (!formato[semana].bloques[bloque]) {
                formato[semana].bloques[bloque] = {
                    bloque: bloque,
                    total_plan: 0,
                    total_ejecutado: 0,
                    datos: []
                };
                formato[semana].bloques_array.push(bloque);
            }
            formato[semana].bloques[bloque].total_plan += item.plan_plantas ?? 0;
            formato[semana].bloques[bloque].total_ejecutado += item.total_plantas ?? 0;
            formato[semana].bloques[bloque].datos.push(item);
        }
        setreporteFormato(Object.values(formato));
    }

    const formatoCommas = (numero) => {
        if (numero === null || numero === undefined || Number.isNaN(Number(numero))) {
            return '0';
        }

        return Number(numero).toLocaleString('en-US');
    }

    return (
        <table className='table table-sm' >
            <thead>
                <tr>
                    <th scope='col' className='text-start'>SEMANA</th>
                    <th scope='col' className='text-end'>PLAN</th>
                    <th scope='col' className='text-end'>EJECUTADO</th>
                    <th scope='col' className='text-center'>AVANCE</th>
                    <th scope='col' className='text-center'>BLOQUES</th>
                </tr>
            </thead>
            <tbody>
                {reporteFormato.length === 0 && (
                    <tr>
                        <td colSpan="7" className="text-center th  h2 text-300">No hay datos disponibles</td>
                    </tr>
                )}
                {
                    reporteFormato.map((semana, index) => (
                        <React.Fragment key={index}>
                            <tr className={`${seleccionesLocal.index !== -1 && seleccionesLocal.index !== index ? 'tr-semitrasparent' : 'tr'}`} onClick={() => setseleccionesLocal({ index: seleccionesLocal.index === index ? -1 : index, verDias: -1 })}>
                                <td scope='row' className='th text-bold text-l'>{semana.semana}</td>
                                <td className='text-300 text-end th'>{formatoCommas(semana.total_plan)}</td>
                                <td className='text-300 text-end th'>{formatoCommas(semana.total_ejecutado)}</td>
                                <td className='text-center th'>{(semana.total_plan !== 0 ? (semana.total_ejecutado / semana.total_plan) * 100 : 0).toFixed(2)}%</td>
                                <td className='text-center th'>{semana.bloques_array.length}</td>
                            </tr>
                            {seleccionesLocal.index !== -1 && seleccionesLocal.index === index && (
                                <tr>
                                    <td colSpan="7" className="text-center th">
                                        <div className='bw-1300 pt-1 pb-5'>
                                            <table className='table table-sm text-s opacity-90'>
                                                <tbody>
                                                    {semana.bloques_array.map((bloqueItem, i) => (
                                                        <React.Fragment key={i}>
                                                            <tr className='pointer'
                                                                style={semana.bloques[bloqueItem].total_plan > semana.bloques[bloqueItem].total_ejecutado ? { 'fontStyle': 'italic', fontFamily: "Arial" } : {}}
                                                                onClick={() => setseleccionesLocal({ ...seleccionesLocal, verDias: seleccionesLocal.verDias === i ? -1 : i })}>
                                                                <td className="text-bold text-start text-m">
                                                                    {bloqueItem}
                                                                    {semana.bloques[bloqueItem].datos.length > 1 && <span className='text-s ms-2 text-300 opacity-60'> <span className='text-bold text-red3'>({semana.bloques[bloqueItem].datos.length})</span> reg.</span>}
                                                                </td>
                                                                <td className="text-bold text-end text-m">
                                                                    <span className='text-300 text-m ms-4'>{formatoCommas(semana.bloques[bloqueItem].total_plan)}<span className='text-s'> Plan</span></span>
                                                                </td>
                                                                <td className="text-bold text-end text-m">
                                                                    <span className='text-300 text-m ms-4'>{formatoCommas(semana.bloques[bloqueItem].total_ejecutado)}<span className='text-s'> Ejec.</span></span>
                                                                </td>
                                                            </tr>
                                                            {seleccionesLocal.verDias !== -1 && seleccionesLocal.verDias === i && (
                                                                <tr>
                                                                    <td className="" colSpan="3">
                                                                        <table className='table table-sm text-s table-hover'>
                                                                            <thead>
                                                                                <tr className='text-muted'>
                                                                                    <th style={{ fontSize: 'small' }} scope='col'>TASPL.</th>
                                                                                    <th style={{ fontSize: 'small' }} scope='col'>CORTE</th>
                                                                                    <th style={{ fontSize: 'small' }} scope='col'>PLAN</th>
                                                                                    <th style={{ fontSize: 'small' }} scope='col'>EJECT.</th>
                                                                                    <th style={{ fontSize: 'small' }} scope='col'>RANCHO</th>
                                                                                    <th style={{ fontSize: 'small' }} scope='col'>VALVULA</th>
                                                                                    <th style={{ fontSize: 'small' }} scope='col'>CAMAS</th>
                                                                                    <th style={{ fontSize: 'small' }} scope='col'>METROS</th>
                                                                                    <th style={{ fontSize: 'small' }} scope='col'>DENSIDAD</th>
                                                                                    <th style={{ fontSize: 'small' }} scope='col'>LUNES</th>
                                                                                    <th style={{ fontSize: 'small' }} scope='col'>MARTES</th>
                                                                                    <th style={{ fontSize: 'small' }} scope='col'>MIÉRCOLES</th>
                                                                                    <th style={{ fontSize: 'small' }} scope='col'>JUEVES</th>
                                                                                    <th style={{ fontSize: 'small' }} scope='col'>VIERNES</th>
                                                                                    <th style={{ fontSize: 'small' }} scope='col'>SÁBADO</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {
                                                                                    semana.bloques[bloqueItem].datos.map((bloqueDatos, j) => (
                                                                                        <tr key={j + "-" + i} style={bloqueDatos.total_plantas < bloqueDatos.plan_plantas ? { 'fontStyle': 'italic', fontWeight: 'bold' } : {}}>
                                                                                            <td className='text-bold'>{bloqueDatos.semana_trasplante}</td>
                                                                                            <td >{bloqueDatos.semana_cosecha}</td>
                                                                                            <td >{bloqueDatos.plan_plantas}</td>
                                                                                            <td className={bloqueDatos.total_plantas < bloqueDatos.plan_plantas ? 'text-bold text-red3' : ''}>{bloqueDatos.total_plantas}</td>
                                                                                            <td >{bloqueDatos.rancho}</td>
                                                                                            <td >{bloqueDatos.valvula}</td>
                                                                                            <td >{bloqueDatos.cama_inicio} - {bloqueDatos.cama_fin}</td>
                                                                                            <td >{bloqueDatos.metros2_siembra}</td>
                                                                                            <td >{bloqueDatos.metros2_siembra > 0 ? Math.round(bloqueDatos.total_plantas / bloqueDatos.metros2_siembra * 100) / 100 : 0}</td>
                                                                                            <td className={bloqueDatos.lunes ? 'text-bold text-blue3' : ''}>{formatoCommas(bloqueDatos.lunes)}</td>
                                                                                            <td className={bloqueDatos.martes ? 'text-bold text-blue3' : ''}>{formatoCommas(bloqueDatos.martes)}</td>
                                                                                            <td className={bloqueDatos.miercoles ? 'text-bold text-blue3' : ''}>{formatoCommas(bloqueDatos.miercoles)}</td>
                                                                                            <td className={bloqueDatos.jueves ? 'text-bold text-blue3' : ''}>{formatoCommas(bloqueDatos.jueves)}</td>
                                                                                            <td className={bloqueDatos.viernes ? 'text-bold text-blue3' : ''}>{formatoCommas(bloqueDatos.viernes)}</td>
                                                                                            <td className={bloqueDatos.sabado ? 'text-bold text-blue3' : ''}>{formatoCommas(bloqueDatos.sabado)}</td>
                                                                                        </tr>
                                                                                    ))
                                                                                }
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                            )}

                                                        </React.Fragment>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>

                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    ))
                }
            </tbody>
        </table>
    )
}

export default TablaEjecucionSemana;